/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeKnownSpawnerListResponse,
  ApiEnvelopeSpawnerUpgradeConfigCreatedResponse,
  ApiEnvelopeSpawnerUpgradeConfigListResponse,
  ApiEnvelopeSpawnerUpgradeEmptyResponse,
  ApiEnvelopeSpawnerUpgradeRunResponse,
  RunSpawnerUpgradeRequest,
  SpawnerUpgradeConfigInputDto,
  SpawnerUpgradeStopSpawnerUpgradeParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type spawnerUpgradeGetSpawnerUpgradeConfigsResponse200 = {
  data: ApiEnvelopeSpawnerUpgradeConfigListResponse
  status: 200
}

export type spawnerUpgradeGetSpawnerUpgradeConfigsResponseSuccess = (spawnerUpgradeGetSpawnerUpgradeConfigsResponse200) & {
  headers: Headers;
};
;

export type spawnerUpgradeGetSpawnerUpgradeConfigsResponse = (spawnerUpgradeGetSpawnerUpgradeConfigsResponseSuccess)

export const getSpawnerUpgradeGetSpawnerUpgradeConfigsUrl = () => {




  return `/api/SpawnerUpgrade`
}

export const useSpawnerUpgradeGetSpawnerUpgradeConfigsHook = (): ( options?: RequestInit) => Promise<spawnerUpgradeGetSpawnerUpgradeConfigsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getSpawnerUpgradeGetSpawnerUpgradeConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type spawnerUpgradeCreateSpawnerUpgradeConfigResponse200 = {
  data: ApiEnvelopeSpawnerUpgradeConfigCreatedResponse
  status: 200
}

export type spawnerUpgradeCreateSpawnerUpgradeConfigResponseSuccess = (spawnerUpgradeCreateSpawnerUpgradeConfigResponse200) & {
  headers: Headers;
};
;

export type spawnerUpgradeCreateSpawnerUpgradeConfigResponse = (spawnerUpgradeCreateSpawnerUpgradeConfigResponseSuccess)

export const getSpawnerUpgradeCreateSpawnerUpgradeConfigUrl = () => {




  return `/api/SpawnerUpgrade`
}

export const useSpawnerUpgradeCreateSpawnerUpgradeConfigHook = (): (spawnerUpgradeConfigInputDto?: SpawnerUpgradeConfigInputDto, options?: RequestInit) => Promise<spawnerUpgradeCreateSpawnerUpgradeConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (spawnerUpgradeConfigInputDto?: SpawnerUpgradeConfigInputDto, options?: RequestInit) => {

        return customFetcher(getSpawnerUpgradeCreateSpawnerUpgradeConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(spawnerUpgradeConfigInputDto)
  }
);
      }
  }


export type spawnerUpgradeGetKnownSpawnersResponse200 = {
  data: ApiEnvelopeKnownSpawnerListResponse
  status: 200
}

export type spawnerUpgradeGetKnownSpawnersResponseSuccess = (spawnerUpgradeGetKnownSpawnersResponse200) & {
  headers: Headers;
};
;

export type spawnerUpgradeGetKnownSpawnersResponse = (spawnerUpgradeGetKnownSpawnersResponseSuccess)

export const getSpawnerUpgradeGetKnownSpawnersUrl = () => {




  return `/api/SpawnerUpgrade/spawners`
}

export const useSpawnerUpgradeGetKnownSpawnersHook = (): ( options?: RequestInit) => Promise<spawnerUpgradeGetKnownSpawnersResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getSpawnerUpgradeGetKnownSpawnersUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type spawnerUpgradeUpdateSpawnerUpgradeConfigResponse200 = {
  data: ApiEnvelopeSpawnerUpgradeEmptyResponse
  status: 200
}

export type spawnerUpgradeUpdateSpawnerUpgradeConfigResponse404 = {
  data: ApiEnvelopeSpawnerUpgradeEmptyResponse
  status: 404
}

export type spawnerUpgradeUpdateSpawnerUpgradeConfigResponseSuccess = (spawnerUpgradeUpdateSpawnerUpgradeConfigResponse200) & {
  headers: Headers;
};
export type spawnerUpgradeUpdateSpawnerUpgradeConfigResponseError = (spawnerUpgradeUpdateSpawnerUpgradeConfigResponse404) & {
  headers: Headers;
};

export type spawnerUpgradeUpdateSpawnerUpgradeConfigResponse = (spawnerUpgradeUpdateSpawnerUpgradeConfigResponseSuccess | spawnerUpgradeUpdateSpawnerUpgradeConfigResponseError)

export const getSpawnerUpgradeUpdateSpawnerUpgradeConfigUrl = (id: string,) => {




  return `/api/SpawnerUpgrade/${id}`
}

export const useSpawnerUpgradeUpdateSpawnerUpgradeConfigHook = (): (id: string,
    spawnerUpgradeConfigInputDto?: SpawnerUpgradeConfigInputDto, options?: RequestInit) => Promise<spawnerUpgradeUpdateSpawnerUpgradeConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    spawnerUpgradeConfigInputDto?: SpawnerUpgradeConfigInputDto, options?: RequestInit) => {

        return customFetcher(getSpawnerUpgradeUpdateSpawnerUpgradeConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(spawnerUpgradeConfigInputDto)
  }
);
      }
  }


export type spawnerUpgradeDeleteSpawnerUpgradeConfigResponse200 = {
  data: ApiEnvelopeSpawnerUpgradeEmptyResponse
  status: 200
}

export type spawnerUpgradeDeleteSpawnerUpgradeConfigResponse404 = {
  data: ApiEnvelopeSpawnerUpgradeEmptyResponse
  status: 404
}

export type spawnerUpgradeDeleteSpawnerUpgradeConfigResponseSuccess = (spawnerUpgradeDeleteSpawnerUpgradeConfigResponse200) & {
  headers: Headers;
};
export type spawnerUpgradeDeleteSpawnerUpgradeConfigResponseError = (spawnerUpgradeDeleteSpawnerUpgradeConfigResponse404) & {
  headers: Headers;
};

export type spawnerUpgradeDeleteSpawnerUpgradeConfigResponse = (spawnerUpgradeDeleteSpawnerUpgradeConfigResponseSuccess | spawnerUpgradeDeleteSpawnerUpgradeConfigResponseError)

export const getSpawnerUpgradeDeleteSpawnerUpgradeConfigUrl = (id: string,) => {




  return `/api/SpawnerUpgrade/${id}`
}

export const useSpawnerUpgradeDeleteSpawnerUpgradeConfigHook = (): (id: string, options?: RequestInit) => Promise<spawnerUpgradeDeleteSpawnerUpgradeConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getSpawnerUpgradeDeleteSpawnerUpgradeConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type spawnerUpgradeRunSpawnerUpgradeConfigResponse200 = {
  data: ApiEnvelopeSpawnerUpgradeRunResponse
  status: 200
}

export type spawnerUpgradeRunSpawnerUpgradeConfigResponse400 = {
  data: ApiEnvelopeSpawnerUpgradeRunResponse
  status: 400
}

export type spawnerUpgradeRunSpawnerUpgradeConfigResponse404 = {
  data: ApiEnvelopeSpawnerUpgradeRunResponse
  status: 404
}

export type spawnerUpgradeRunSpawnerUpgradeConfigResponseSuccess = (spawnerUpgradeRunSpawnerUpgradeConfigResponse200) & {
  headers: Headers;
};
export type spawnerUpgradeRunSpawnerUpgradeConfigResponseError = (spawnerUpgradeRunSpawnerUpgradeConfigResponse400 | spawnerUpgradeRunSpawnerUpgradeConfigResponse404) & {
  headers: Headers;
};

export type spawnerUpgradeRunSpawnerUpgradeConfigResponse = (spawnerUpgradeRunSpawnerUpgradeConfigResponseSuccess | spawnerUpgradeRunSpawnerUpgradeConfigResponseError)

export const getSpawnerUpgradeRunSpawnerUpgradeConfigUrl = (id: string,) => {




  return `/api/SpawnerUpgrade/${id}/run`
}

export const useSpawnerUpgradeRunSpawnerUpgradeConfigHook = (): (id: string,
    runSpawnerUpgradeRequest?: RunSpawnerUpgradeRequest, options?: RequestInit) => Promise<spawnerUpgradeRunSpawnerUpgradeConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runSpawnerUpgradeRequest?: RunSpawnerUpgradeRequest, options?: RequestInit) => {

        return customFetcher(getSpawnerUpgradeRunSpawnerUpgradeConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runSpawnerUpgradeRequest)
  }
);
      }
  }


export type spawnerUpgradeStopSpawnerUpgradeResponse200 = {
  data: ApiEnvelopeSpawnerUpgradeEmptyResponse
  status: 200
}

export type spawnerUpgradeStopSpawnerUpgradeResponse404 = {
  data: ApiEnvelopeSpawnerUpgradeEmptyResponse
  status: 404
}

export type spawnerUpgradeStopSpawnerUpgradeResponseSuccess = (spawnerUpgradeStopSpawnerUpgradeResponse200) & {
  headers: Headers;
};
export type spawnerUpgradeStopSpawnerUpgradeResponseError = (spawnerUpgradeStopSpawnerUpgradeResponse404) & {
  headers: Headers;
};

export type spawnerUpgradeStopSpawnerUpgradeResponse = (spawnerUpgradeStopSpawnerUpgradeResponseSuccess | spawnerUpgradeStopSpawnerUpgradeResponseError)

export const getSpawnerUpgradeStopSpawnerUpgradeUrl = (id: string,
    params?: SpawnerUpgradeStopSpawnerUpgradeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/SpawnerUpgrade/${id}/stop?${stringifiedParams}` : `/api/SpawnerUpgrade/${id}/stop`
}

export const useSpawnerUpgradeStopSpawnerUpgradeHook = (): (id: string,
    params?: SpawnerUpgradeStopSpawnerUpgradeParams, options?: RequestInit) => Promise<spawnerUpgradeStopSpawnerUpgradeResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: SpawnerUpgradeStopSpawnerUpgradeParams, options?: RequestInit) => {

        return customFetcher(getSpawnerUpgradeStopSpawnerUpgradeUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


